export default "__VITE_ASSET__Yhjk9aic__"